import React, {Component} from 'react';
import './UploadCSV.scss';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import csvFormat from "../../../../../assets/csv/csv_format_upload_corporate_users.csv";
import Files from "react-files";
import {Button as SementicBtn, Icon} from "semantic-ui-react";
import {Col, Row} from "reactstrap";
import {message, Spin, Tooltip} from "antd";
import base64 from "base-64";
import * as common from "../../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import * as tableHeaders from '../../../../../const/table/TableHeaders';
import * as DropDownConst from "../../../../../store/Reducer/DropDownConst";
import * as validator from "../../../../../util/Validator";
import * as EmailValidator from "email-validator";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import apiConfig from "../../../../../axios/axios_api_services";
import * as keys from "../../../../../const/key/Key";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";

class App extends Component {
  state = {
    file: [],
    json: [],
    errorjson: [],
    errorsList: [],
    errortable: false,
  };
  submitHandler = () => {
    let customizeDepartments = [];
    let errorsList = [];
    let {json} = this.state;
    let {departmentArray} = this.props;

    if(departmentArray.length !== 0){
      departmentArray.map((obj)=>{
        customizeDepartments.push(obj.text)
      })
    }else{
      common.warningAlert("Departments not found!", 1);
      return;
    }


    if (json.length !== 0) {
      json.map((obj, index) => {
        if (DropDownConst.userTitle.find(object => object.value.toLowerCase() === obj.title.toLowerCase()) === undefined) errorsList.push({index: index, msg: "Title value does not match. Ex: Mr, Mrs, Miss, Ms, Dr, Ven", value: obj.title});
        if (obj.gender !== "" && DropDownConst.gender.find(object => object.value.toLowerCase() === obj.gender.toLowerCase()) === undefined) errorsList.push({index: index, msg: "Gender value does not match. Ex: Male, Female", value: obj.gender});

        if (obj.firstName === "") errorsList.push({index: index, msg: "First name cannot be empty", value: obj.firstName});
        if (obj.lastName === "") errorsList.push({index: index, msg: "Last name cannot be empty", value: obj.lastName});

        if (!EmailValidator.validate(obj.email)) errorsList.push({index: index, msg: "Invalid email address. Ex: user@company.com", value: obj.email});
        if (!validator.mobileNumValidator(obj.mobile, null, 1)) errorsList.push({index: index, msg: "Invalid mobile number. Ex: 07XXXXXXXX", value: obj.mobile});

        let isExitIdentType = DropDownConst.Identifications().find(object => object.value.toLowerCase() === obj.identificationType.toLowerCase());

        if (isExitIdentType === undefined) errorsList.push({index: index, msg: "Identification type does not match. Ex: NIC, Driving Licence, Passport", value: obj.identificationType});
        if (isExitIdentType !== undefined && !validator.identityValueValidator(obj.identificationValue, isExitIdentType.value, null)) errorsList.push({index: index, msg: "Invalid identification value for "+isExitIdentType.value, value: obj.identificationValue});

        if (obj.district !== "" && DropDownConst.districs.find(object => object.value.toLowerCase() === obj.district.toLowerCase()) === undefined) errorsList.push({index: index, msg: "District is not compatible (Please confirm the spelling)", value: obj.district});

        if (obj.emergency_mobile !== "" && !validator.mobileNumValidator(obj.emergency_mobile, null, 1)) errorsList.push({index: index, msg: "Invalid emergency mobile number. Ex: 07XXXXXXXX", value: obj.emergency_mobile});

        if (obj.empId === "") errorsList.push({index: index, msg: "Emp ID cannot be empty", value: obj.empId});
        if (departmentArray.find(object => object.text.toLowerCase() === obj.department.toLowerCase()) === undefined) errorsList.push({index: index, msg: `Department does not match. Ex: ${customizeDepartments.join(", ")}`, value: obj.department});
        if (obj.designation === "") errorsList.push({index: index, msg: "Designation cannot be empty", value: obj.designation});})
    }
    this.setState({
      errorsList: errorsList
    });
    if (errorsList.length === 0) {
      swal({
        title: "Are you sure, you want to proceed?",
        icon: are_you_sure_icon,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      })
        .then((value) => {
          switch (value) {
            case "action":
              this.sendToData(json);
              break;
            default:
          }
        });
    }
  };
  sendToData = (jsonList) => {
    let array = [];
    let {departmentArray} = this.props;

    if(jsonList.length !== 0) {
      jsonList.map((obj)=> {

        array.push({
          title: DropDownConst.userTitle.find(object => object.value.toLowerCase() === obj.title.toLowerCase()).value,
          firstName: obj.firstName,
          lastName: obj.lastName,
          gender: obj.gender !== "" ? DropDownConst.gender.find(object => object.value.toLowerCase() === obj.gender.toLowerCase()).value : "None",
          mobile: obj.mobile,
          identificationType: DropDownConst.Identifications().find(object => object.value.toLowerCase() === obj.identificationType.toLowerCase()).value,
          identificationValue: obj.identificationValue,

          email: obj.email,
          budgetReferance: obj.budgetReferance,
          otherReferance: obj.otherReferance,

          empId: obj.empId,
          department: departmentArray.find(object => object.text.toLowerCase() === obj.department.toLowerCase()).value,

          designation: obj.designation,
          extention: obj.extention,
          staffId: null,

          addressEntities: [
            {
              line1: obj.line1,
              line2: obj.line2,
              city: obj.city,
              district: obj.district !== "" ? DropDownConst.districs.find(object => object.value.toLowerCase() === obj.district.toLowerCase()).value : "",
              province: obj.province,
              postalCode: obj.postalCode,
              country: "Sri Lanka",
              status: 1
            }
          ],
          userEmergencyContactEntity: {
            emergency_mobile: obj.emergency_mobile,
            fullName: obj.fullName
          },
        })
      })
    }else{
      common.warningAlert("Try again later!", 1);
      return;
    }

    const obj = {
      corporateId: this.props.usr_obj.corporateId,
      saveUserRequestDTOList: array
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };

    axiosTags.put(apiConfig.CORPORATE_USERS_BULK_UPLOAD, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.closeModal();
        } else {
          common.warningAlert(response.data.message, 1);
          let errorsList = [];
          if(response.data.errors.length !== 0){
            response.data.errors.map((err,index)=>{
              errorsList.push({index: err.row - 1, msg: err.message, value: null})
            })
          }
          this.setState({errorsList})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToData(jsonList)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    console.log('hy')
    let row = [];
    if (this.state.json.length !== 0) {
      this.state.json.map((obj, index) => {
        row.push({
          index: index + 1,
          ...obj
        });
      })
    }
    let table_data = {columns: tableHeaders.uploadCorporateUsersColumns, rows: row};
    return (
      <div className={"csv-file-users"}>
        <MDBModal isOpen={true} toggle={() => {
        }} size="lg"
                  inline={false}
                  noClickableBodyWithoutBackdrop
                  overflowScroll>
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Upload users via CSV file</MDBModalHeader>
          <MDBModalBody>
            <p className={"offline-warning-txt"}>(Download the <a href={csvFormat}>csv_format.csv</a> file. Modify the
              contents and upload)</p>
            <div style={{display: "inline-flex"}}>
              <Files
                className='files-dropzone'
                onChange={this.onFilesChange("file")}
                accepts={["text/csv", ".csv"]}
                multiple={false}
                maxFileSize={10000000}
                minFileSize={0}
                clickable
              >
                <button className={"file-uploader"}>Choose CSV file&nbsp;&nbsp;
                  <Icon name={"upload"}/>
                </button>
              </Files>
              {
                this.state.json.length !== 0 && !this.state.isSpin ? <div style={{margin: 'auto'}}>
                    <SementicBtn className="px-5 offline-submit" onClick={this.submitHandler}>Submit</SementicBtn>
                    <SementicBtn onClick={this.removeData} className={"offline-remove-btn"} icon='trash alternate'/>
                  </div>
                  : null
              }

            </div>
            {
              this.state.errorsList.length !== 0 ?
                <Row className={"none-margin top-border"}>
                  <Col xs={12} className={"offline-error-title"}>
                    Please find some issues in the following lines. (Includes row number and warning message) <small className={"err-count"}>{this.state.errorsList.length}</small>
                  </Col>
                  <Col xs={12} className={"none-padding scroll-view"}>
                    {
                      this.state.errorsList.map((obj, index) => {
                        return <div className={"error-wrapper"} key={index}>
                          <p className={"index"}>{obj.index + 1}</p>
                            {obj.value !== null ? <div className={"view-error"}>
                            <Tooltip placement="topLeft" title={obj.value ? obj.value : "Empty"}>
                              <p>View Error</p>
                            </Tooltip>
                          </div> : null }
                          <p className={"message"}>{obj.msg}</p>

                        </div>
                      })
                    }
                  </Col>
                  <br/><br/>
                </Row> : null
            }
            <Row>
              {
                this.state.json.length !== 0 && !this.state.isSpin ?
                  <Col>
                    <MDBDataTable
                      id={"users-csv-table"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      paging={true}
                      searching={true}
                      bordered
                      hover
                      data={table_data}/>
                  </Col> : null
              }
              {
                this.state.isSpin ? <Spin/> : null
              }

            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }

  onFilesChange = name => files => {
    if (files.length !== 0) {
      this.onFileChange(name, files[0]);
    } else {
      message.error("Please choose valid file type!");
    }
  };
  onFileChange = async (name, e) => {
    const textDataUrl = await readFile(e);
    this.setState({
      isSpin: false,
      [name]: textDataUrl,
      errorsList: [],
      json: this.base64Decode(textDataUrl, "CSV")
    });
  };
  base64Decode = (bytes, file) => {
    try {
      let split = bytes.split("base64,");
      let decode = base64.decode(split[1]);
      return this.csvToJson(decode);
    } catch (e) {
      console.log("exception", e);
      message.error("Please select " + file + " file!");
    }
  };
  csvToJson = (csv) => {
    try {
      this.setState({isSpin: true});
      let lines = csv.split("\n");
      let result = [];

      let headers = ["title", "gender", "firstName", "lastName", "email", "mobile", "identificationType", "identificationValue", "line1", "line2", "province", "district", "city", "postalCode", "fullName", "emergency_mobile", "empId", "department", "designation", "budgetReferance", "otherReferance", "extention"];
      for (let i = 1; i < lines.length; i++) {
        let obj = {};
        let currentline = lines[i].split(",");
        if (currentline.length > 1) {
          for (let j = 0; j < headers.length; j++) {
            let value = currentline[j].trim();
            if (value.toString() === "") {
              value = "";
            }
            obj[headers[j]] = value;
          }
          result.push(obj);
        }
      }
      if (result.length === 0) {
        common.notifyMessage("Empty file!")
      }
      return result;
    } catch (error) {
      console.log(error)
      common.notifyMessage("Invalid file!");
      return [];
    }
  };
  removeData = () => {
    swal({
      title: "Do you want to remove this data?",
      icon: are_you_sure_icon,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.setState({
              json: [],
              errorsList: [],
            });
            break;
          default:
        }
      });
  };
}

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}
const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
